// W-1 — accueil par défaut sur le Bureau AMO et texte de la cloche.
export const CAPACITE_BUREAU_AMO = "communication.emails";

// Verdict SERVEUR « ce compte peut ouvrir le Bureau » (rôle admin ET module bureau_amo). Fail-closed : seul `true` explicite ouvre.
export const verdictBureau = (permissionContext) => permissionContext?.acces?.bureau_amo === true;

// Cible d'accueil : le Bureau AMO, seulement si le SERVEUR dit que ce compte peut l'ouvrir (rôle admin ET module bureau_amo) et si rien n'est déjà ouvert.
export function accueilParCapacite({ peutOuvrirBureau, activeHub, activeItem }) {
  if (peutOuvrirBureau !== true || activeHub || activeItem) return null;
  return { hub: "communication", item: "ag04-amo" };
}

export function libelleCloche(n) {
  return `${n} ${n > 1 ? "mails prêts ou à trancher" : "mail prêt ou à trancher"}`;
}

// T-404c — le Bureau s'ouvre DIRECTEMENT : tant que les permissions se chargent, ni tableau de bord ni tuiles ne s'affichent (une phrase d'attente seulement).
export function accueilEnAttente({ chargementPermissions, activeHub, activeItem, showHomePage }) {
  return chargementPermissions === true && showHomePage === true && !activeHub && !activeItem;
}

// T-404c — « une page = une tâche » : sur le Bureau, l'écran ne montre que l'en-tête, les trois cases, les cartes, « Demander à … », le menu ☰ et le compte.
// T-406b : même mode pour les Bureaux de Chloé et de Joey (pas de bulle Support, pas de fil d'Ariane sur 3 lignes).
// Vrai seulement quand le SERVEUR autorise CE Bureau ET que ce Bureau est la page ouverte (jamais pour une autre page ni pour le tableau de bord).
export const BUREAUX_SEULS = [
  { hub: "communication", item: "ag04-amo", acces: "bureau_amo" },
  { hub: "commercial", item: "bureau-chloe", acces: "bureau_chloe" },
  { hub: "conformite", item: "bureau-joey", acces: "bureau_joey" },
];

export function bureauSeul({ peutOuvrirBureau, peutOuvrirAcces, activeHub, activeItem, showHomePage, activeGlobalPage, activeDirectionAgent }) {
  if (showHomePage || activeGlobalPage || activeDirectionAgent) return false;
  const b = BUREAUX_SEULS.find((x) => x.hub === activeHub && x.item === activeItem);
  if (!b) return false;
  return b.acces === "bureau_amo" ? peutOuvrirBureau === true : (typeof peutOuvrirAcces === "function" && peutOuvrirAcces(b.acces) === true);
}

export const LIBELLE_BUREAU = "Bureau de Matthieu";
